import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { toastr } from 'react-redux-toastr';

export const CREATE_WHD_REQUEST = 'CREATE_WHD_REQUEST';
export const CREATE_WHD_FAILURE = 'CREATE_WHD_FAILURE';
export const CREATE_WHD_SUCCESS = 'CREATE_WHD_SUCCESS';

function requestCreateWhd() {
  return {
    type: CREATE_WHD_REQUEST,
    isCreatingNewWhd: true
  };
}

function rejectCreateWhd() {
  return {
    type: CREATE_WHD_FAILURE,
    isCreatingNewWhd: false
  };
}

function receiveCreateWhd() {
  return {
    type: CREATE_WHD_SUCCESS,
    isCreatingNewWhd: false
  };
}

export function createWhdStatement(formId, accountId, statementType) {
  return (dispatch) => {
    dispatch(requestCreateWhd());

    const promise = () => ApiService
      .createWhdStatement(formId, accountId, statementType)
      .then((response) => {
        dispatch(receiveCreateWhd(response.data));
        toastr.success('Success', 'Statement Created successfully');
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectCreateWhd, true));
        }
      });
    return promise();
  };
}
